angular.module('swapick')
.controller('SwapsListCtrl', SwapsListCtrl);


function SwapsListCtrl($scope, DataService, DataStrategies,
  $ionicScrollDelegate, $ionicPopup, initialLoaderManager, $q,
  $ionicHistory, $state, $stateParams, Entities, notifyManager ) {

  this.type = $stateParams.type || 'proposte';

  DataStrategies.createPagerMethods(
    this, $scope,
    {
      method:DataService.swaps, callMethodName:'getList', pageSize:50,
      params: () => ({ type:this.type })
    }
  );

  this.objects = [];
  this.meta = {};

  Entities.waitForUser()
  .then((u)=>{
      this.user = u;
  })

  this.dropObject = (obj, idx) => {
    //#TODO: call remote API...
    this.objects.splice(idx, 1);
  }

  this.toSwaps = (type) => {
    $ionicHistory.currentView($ionicHistory.backView());
    $ionicHistory.nextViewOptions({ disableAnimate: true });
    $state.go('app.logged.swaps', {
        type : type
    }, { location:'replace'});
  }

  this.loader = initialLoaderManager.makeLoader(()=>{
    return this.loadMore()
  }, false);

  $scope.$on('$ionicView.beforeEnter', () => {
    if(!this.objects.length){
      this.loader.load();
    }
  });


  this.getItemsForUid = (objs, uId) => {
    let o = _.groupBy(objs, 'utente')
    return o[uId];
  }


  this.askForFeedback = (obj, user) => {

    $scope.tempData = { swapId: obj.id};
    $scope.tempData.tempFeedback = 0;
    var feedbackPopup = $ionicPopup.show({
        title: 'Feedback',
        subTitle: 'Dai una valutazione allo scambio',
        template: `<div class="text-center">
          <div feedback-stars writable="'yes'"
            value="tempData.tempFeedback" star-classes="'star-big'">
          </div></div>`,
        cancelText: 'Annulla',
        scope: $scope,
        buttons: [
          { text: 'Annulla', onTap : (e)=> {
            feedbackPopup.close() }
          },
          {
            text: '<b>OK</b>',
            type: 'button-positive',
            onTap: (e) => {
              if(!$scope.tempData.tempFeedback){
                e.preventDefault();
                return false;
              }
              return $scope.tempData;
            }
          }
        ]
    });

    feedbackPopup.then((res) => {
      if(!res){return}
      return DataService.swaps.one(res.swapId.toString()).all('actions/feedback')
      .post({rating:res.tempFeedback})
      .then((resp)=>{
        notifyManager.success("Feedback salvato!")
      })

    });


  }

  //#TODO: add date check
  this.canArchiveSwap = (swap) => {
    return ((swap.stato === 'accettata') && this.type != 'archivio');
  }

  this.archiveSwap = (swap, idx) => {
    // A confirm dialog
    var confirmPopup = $ionicPopup.confirm({
      title: 'Archivia proposta',
      template: 'Sei sicuro di voler archiviare la proposta?'
    });

    confirmPopup.then((res) => {
      if(res) {
        return DataService.swaps
        .one(swap.id.toString())
        .all('actions/archive')
        .post()
        .then((resp)=>{
          notifyManager.success("Proposta archiviata")
          this.objects.splice(idx, 1);
        })

      }
      return false;
    });

  }

  this.goToItemDetail = (item, user) => {
    let params = { objectId: item.oggetto.id };

    // In other scenario we don't known if the item in really owned by swap user...
    if (user && this.type === 'proposte') {
      params.userId = user.id;
    }

    $state.go("app.logged.object", params);
  };

}



// WEBPACK FOOTER //
// ./src/controllers/swaps-list-controller.js